@switch (column().key) {
  @case (getColumnKey('roles')) {
    <div class="flex flex-wrap gap-3">
      @for (role of model().roles; track role) {
        <app-role [role]="role" />
      }
    </div>
  }
  @case (getColumnKey('status')) {
    <app-user-status [status]="model().status" />
  }
  @case (getColumnKey('accountType')) {
    <app-account-type [type]="model().accountType" />
  }
  @default {
    <app-table-body-no-reference-cell [columnKey]="column().key" />
  }
}
